// extracted by mini-css-extract-plugin
export default {"wrapperDark":"app_wrapperDark__JKPDV"};